const referralProcessItems = {
    colsOrder: ['detail', 'date'],
    cols: {
        detail: {
            content: 'Детали',
            width: 75,
        },
        date: {
            content: 'Дата',
            width: 25,
        },
    },
    deletesCols: [],
    url: 'referralProcessItem',
    emptyInfo: {
        title: 'Начислений пока нет',
        description: 'Они будут отображаться здесь',
    },
} as const;

export default referralProcessItems;
